export const SERVICE_CHARACTERS = 'characters';
export const SERVICE_COMICS = 'comics';

export const DEFAULT_PAGE_LIMIT = 20;

export const IMGE_TYPE = '/portrait_fantastic.jpg';

export const IMG_NOT_FOUND = 'http://i.annihil.us/u/prod/marvel/i/mg/b/40/image_not_available';

export const IMG_SIZE_DIMENSIONS = {
  width: 168,
  height: 252,
};

export const IMG_TYPE_FILTER = '/standard_small.jpg';
export const IMG_SIZE_FILTER = {
  width: 50,
  height: 75,
};

export const PAGE_COMICS = '/comics';
export const PAGE_CHARACTERS = '/personajes';

export const PAGES = [PAGE_COMICS, PAGE_CHARACTERS];
